// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$bookLanguageApiService = {
      language_api_url: `${process.env.VUE_APP_DHARMA_API_URL}/languages`,
      
      /**
       * 取得語言列表
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryTopLevel(additional = '') {
        const url = `${this.language_api_url}/top-level`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      }
    }
  }
}
